<!--
    描述：指标分析 --- 列过滤弹窗模块
    时间：2020-06-04
    Created by ws
-->
<template>
    <div class="h100">
        <el-table ref="xTable"
                  :height="380"
                  :data="filterData"
                  highlight-current-row
                  border
                  stripe>
            <el-table-column label="项目名称"
                             prop="projectName"
                             header-align="center"
                             align="left"
                             show-overflow-tooltip
                             min-width="150">
            </el-table-column>
            <el-table-column align="center"
                             width="90"
                             v-for="(item, index) in listData"
                             :key="'checkAll' + index">
                <template slot="header"
                          slot-scope="scope">
                    <el-checkbox style="color:#ecf5ff" v-model="item.isChecked"
                                 @change="handleCheckAll($event, item.value)">{{ item.name }}
                    </el-checkbox>
                </template>
                <template slot-scope="scope">
                    <el-checkbox disabled
                                 v-if="scope.row.sixCalculationMap[item.value] === 2"
                                 :value="false"></el-checkbox>
                    <el-checkbox v-else
                                 :true-label="1"
                                 :false-label="0"
                                 v-model="scope.row.sixCalculationMap[item.value]"></el-checkbox>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    export default {
        props: {
            tableData: {
                type: Array,
                default: () => {
                    return []
                }
            }
        },
        data() {
            return {
                listData: [
                    {
                        value: 'estimateMoney',
                        isChecked: false,
                        name: '概算价',
                    },
                    {
                        value: 'controlMoney',
                        isChecked: false,
                        name: '控制价',
                    },
                    {
                        value: 'biddingMoney',
                        isChecked: false,
                        name: '中标价',
                    },
                    {
                        value: 'reportMoney',
                        isChecked: false,
                        name: '报审价',
                    },
                    {
                        value: 'beforeMoney',
                        isChecked: false,
                        name: '初审价',
                    },
                    {
                        value: 'afterMoney',
                        isChecked: false,
                        name: '审定价',
                    }
                ],
                checkAll: {
                    estimate: false,
                    control: false,
                    bidding: false,
                    report: false,
                    before: false,
                    after: false
                },
                filterData: []
            }
        },
        methods: {
            // 表头全选事件
            handleCheckAll(val, type) {
                this.filterData.map(x => {
                    if (x.sixCalculationMap[type] !== 2) {
                        x.sixCalculationMap[type] = val ? 1 : 0
                    }
                })
            },
            // 保存事件
            doSave() {
                this.$emit('onSuccess', this.filterData)
            }
        },
        created() {
            this.filterData = this.tableData
            console.log(this.filterData)
        }
    }
</script>


<style scoped lang="less">
</style>
